import authDesign from './authDesign'
import plaka from './plaka'

export { authDesign, plaka }
export default [authDesign, plaka]
